// src/components/SaleCancelForm/parts/SaleFoundCardHeader.tsx
import React from 'react';
import { FileText, Hash as HashIcon, BadgeDollarSign } from 'lucide-react';

type Props = {
  documentTypeName?: string | null;
  controlNumber?: string | null;
  amountLabel: string;
};

const SaleFoundCardHeader: React.FC<Props> = ({
  documentTypeName,
  controlNumber,
  amountLabel,
}) => (
  <div
    className={[
      'flex flex-wrap items-center justify-between gap-3',
      'rounded-lg border border-slate-200 dark:border-slate-700',
      'bg-slate-50 dark:bg-slate-800/40',
      'px-3 sm:px-4 py-2.5',
    ].join(' ')}
  >
    <div className="flex items-center gap-2 flex-wrap">
      {/* Chip tipo documento */}
      <span className="inline-flex items-center gap-2 rounded-full border border-primary/30 text-primary bg-white/70 dark:bg-boxdark/60 px-3 py-1 text-[11px] sm:text-xs font-semibold">
        <FileText className="h-3.5 w-3.5" />
        {documentTypeName ?? 'Documento'}
      </span>

      {/* Chip control */}
      {!!controlNumber && (
        <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-slate-700 text-body dark:text-bodydark bg-white/70 dark:bg-boxdark/60 px-3 py-1 text-[11px] sm:text-xs">
          <HashIcon className="h-3.5 w-3.5" />
          <span className="font-mono">{controlNumber}</span>
        </span>
      )}
    </div>

    {/* Monto */}
    <div className="inline-flex items-center gap-2 rounded-full border border-success/30 text-success bg-success/10 px-3 py-1 text-[11px] sm:text-xs font-semibold">
      <BadgeDollarSign className="h-3.5 w-3.5" />
      {amountLabel}
    </div>
  </div>
);

export default SaleFoundCardHeader;
